import styled from "styled-components";

export const ClickHandler = styled.div`
    pointer-events: ${(props) => (props?.noClick ? 'none' : 'all')};
    opacity: ${(props) => (props?.noClick ? '0.6' : "1")};
`;